<template>
  <div id="connect-button">
    <vs-button
      :color="color"
      type="filled"
      class="align-right"
      @click="open()"
    >
      <slot></slot>
    </vs-button>
  </div>
</template>

<script>

import { openSignInWindow } from "@/components/integrated-onboarding-dialog/open-popup";
import { getBaseUrl, getCurrentTenant } from "@/utils";

export default {
  name: "connect-button",
  props: {
    color: String,
    instanceId: Number,
    queryParameters: Object
  },
  mounted() {
    this.setPermissionUrl();
  },
  watch: {},
  computed:{
    redirectTo(){
      return `${getBaseUrl()}${getCurrentTenant()}/redirect?instance_id=${this.instanceId}`
    },
    permissionUrl() {
      return `${this.baseUrl}/dashboard/app/${this.partnerId}/permissions?redirect_url=${this.redirectTo}`
    },
    partnerId(){
      return process.env.VUE_APP_WHATSAPP_DIALOG_PARTNER_ID
    },
    baseUrl(){
      return process.env.VUE_APP_BOKER_DIALOG_BASE_URL
    }
  },
  methods: {
    open(){
      this.$emit('window-open', true);
      return openSignInWindow(this.setPermissionUrl())
    },
    setPermissionUrl() {
      let url = this.permissionUrl;

      if (this.queryParameters) {
        const values = Object.values(this.queryParameters);
        const keys = Object.keys(this.queryParameters);
        keys.forEach((key, idx) => {
          url += `&${key}=${values[idx]}`;
        });
      }

      return url;
    }
  }
}

</script>